import { Button, Flex } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';

import { RemoveButton } from '@components/RemoveButton';

import './styles.scss';

interface NavBarProps {
  nextLabel?: string;
  nextDisabled?: boolean;
  hasRemoveButton?: boolean;
  onNext?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onRemove?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const NavBar = ({
  nextLabel = '',
  nextDisabled = false,
  hasRemoveButton = false,
  onNext,
  onRemove,
}: NavBarProps) => (
  <Flex
    alignItems={{
      desktop: 'center',
      tablet: 'center',
      mobile: hasRemoveButton ? 'center' : 'end',
    }}
    className={clsx('navBar', {
      'navBar--double-row': hasRemoveButton,
    })}
  >
    <Flex
      className="wrapper"
      direction={{
        mobile: 'column-reverse',
        tablet: 'row',
      }}
      spacing="lg"
      justifyContent="end"
    >
      {hasRemoveButton && onRemove ? (
        <RemoveButton onClick={onRemove} />
      ) : (
        // Ensures that submit button is always on the right side of the navbar
        <span />
      )}
      {nextLabel && onNext && (
        <Button
          type="submit"
          data-testid="navbar-next-button"
          onClick={onNext}
          disabled={nextDisabled}
          size="md"
        >
          {nextLabel}
        </Button>
      )}
    </Flex>
  </Flex>
);

export { NavBar };
